export default __webpack_public_path__ + "static/media/lifecycle.2571c94e.png";